module.exports = __webpack_public_path__ + "static/smh-logo-b2d1e257ccb6529acc6ec0dbeae062de.svg";